/**
 * Contact Log Service
 * TypeScript functions that call the Python API for contact logs
 */
import { apiGet, apiPut, apiDelete } from './api';
import { ContactLog } from '../types/contactLog';

/**
 * Get contact logs for a specific individual
 * Returns logs sorted by date descending (most recent first)
 */
export async function getContactLogsByIndividual(individualID: number): Promise<ContactLog[]> {
  const response = await apiGet<ContactLog[]>(`/individuals/${individualID}/contacts`);

  if (!response.success) {
    const serverMsg = response.error?.message || '';
    console.error('Fetch contact logs error:', { individualID, error: response.error });
    throw new Error(serverMsg || 'Unable to load contact logs. Please refresh and try again.');
  }

  return response.data;
}

/**
 * Update an existing contact log
 */
export async function updateContactLog(
  contactLogID: number,
  data: Partial<ContactLog>
): Promise<ContactLog> {
  const response = await apiPut<ContactLog>(`/contact-logs/${contactLogID}`, data);

  if (!response.success) {
    const serverMsg = response.error?.message || '';
    console.error('Update contact log error:', { contactLogID, error: response.error });
    throw new Error(serverMsg || 'Unable to update contact log. Please try again.');
  }

  return response.data;
}

/**
 * Delete a contact log (admin only)
 */
export async function deleteContactLog(contactLogID: number): Promise<void> {
  const response = await apiDelete(`/contact-logs/${contactLogID}`);

  if (!response.success) {
    const serverMsg = response.error?.message || '';
    console.error('Delete contact log error:', { contactLogID, error: response.error });
    throw new Error(serverMsg || 'Unable to delete contact log. Please try again.');
  }
}
